import { render, staticRenderFns } from "./TextareaV1.vue?vue&type=template&id=53b4d670&scoped=true&"
import script from "./TextareaV1.vue?vue&type=script&lang=js&"
export * from "./TextareaV1.vue?vue&type=script&lang=js&"
import style0 from "./TextareaV1.vue?vue&type=style&index=0&id=53b4d670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b4d670",
  null
  
)

export default component.exports